import React, {useEffect} from "react";
import {CustomCloseModalIcon} from "../ui-base/icons/custom-close-modal-icon";
import {Grid} from "@mui/material";
import styled from "styled-components";
import {Colors} from "../../theme/colors";
import {ManuscriptService} from "../../services/manuscript.service";
import {useTranslation} from "react-i18next";

export const NoteModal: React.FC<{open: boolean, setOpen: Function, id: string}> = ({open, setOpen, id}) => {
    const [note, setNote] = React.useState<string>('');
    const { t } = useTranslation('common');

    const loadNote = async (id: string) => {
        const note = await ManuscriptService.getNote(id);

        setNote(note.book_note);
    }

    useEffect(() => {
        if (open) {
            setNote('');
            loadNote(id);
        }
    }, [id, open]);

    return <>
        { open &&
        <StyledBlockedContent container direction={"column"} justifyContent={"center"} alignContent={"center"}>
            <StyledBlockedInfo item container direction={"column"} alignItems={"center"}>
                {setOpen &&
                <StyledCloseButton onClick={() => {
                    setOpen(false);
                }}><CustomCloseModalIcon/></StyledCloseButton>
                }

                <Grid item>
                    <StyledBlockedTitle>{t('noteModal.title')}</StyledBlockedTitle>
                </Grid>

                <StyledNoteBlock item>
                    <StyledP>{note}</StyledP>
                </StyledNoteBlock>
                {/*<StyledBlockedImgContainer item>*/}
                {/*    <img src={marketBook} alt={'Modal image'}/>*/}
                {/*</StyledBlockedImgContainer>*/}



                {/*<Grid item>*/}
                {/*    <StyledButton type={"button"} color={"violet"} onClick={buttonNavigate}>Zobacz ofertę</StyledButton>*/}
                {/*</Grid>*/}
            </StyledBlockedInfo>
        </StyledBlockedContent>
        }
    </>
}

const StyledBlockedContent = styled(Grid)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255,255,255,0.8561799719887955);
  z-index: 1111111;
`;

const StyledBlockedInfo = styled(Grid)`
  background: #FBF5FF;
  border: 1px solid ${Colors.lightViolet};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  max-width: 800px !important;
  position: relative;
  padding-bottom: 1rem;
  
  & > div {
    padding-top: 1rem;
  }
`;

const StyledNoteBlock = styled(Grid)`
  padding: 1rem;
`;

const StyledP = styled('p')`
  white-space: pre-line;
`;

const StyledBlockedTitle = styled('h6')`
  font-size: 1.2rem;
  font-weight: 600;
  color: ${Colors.lightViolet};
  text-align: center;
`;

const StyledCloseButton = styled('div')`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  padding-top: 0 !important;
`;
